import {
  buildHomepageCopy,
  type RomaLocationCopy,
} from "@/lib/marketing-location-copy";
import { getLocationBySlug } from "@/lib/restaurant-platform";

export const ROMA_BRANCHES = ["southern-highlands", "henderson"] as const;
export type RomaBranch = (typeof ROMA_BRANCHES)[number];

export function isRomaBranch(value: unknown): value is RomaBranch {
  return (
    typeof value === "string" &&
    (ROMA_BRANCHES as readonly string[]).includes(value)
  );
}

export function romaBranchLabel(branch: RomaBranch): string {
  return branch === "henderson" ? "Henderson" : "Southern Highlands";
}

/**
 * Marketing copy for a Roma room. Sourced from the same `romaLocations`
 * block the homepage and private events cards render so addresses and
 * phones never diverge.
 */
export function resolveRomaBranchCopy(
  branch: RomaBranch | undefined,
): RomaLocationCopy | null {
  if (!branch) return null;
  const roma = getLocationBySlug("roma-kitchen-southern-highlands");
  const rooms = buildHomepageCopy(roma).romaLocations ?? [];
  return rooms.find((room) => room.slug === branch) ?? null;
}

export function validateRomaBranchField({
  isRoma,
  value,
}: {
  isRoma: boolean;
  value: string;
}): string | undefined {
  if (!isRoma) return undefined;
  return isRomaBranch(value) ? undefined : "Choose a location.";
}
